import gql from 'graphql-tag';

const updateMajorsMessaging = gql`
  mutation updateCompetitorsMessaging($input: updateAMMessageCompetitorsInput!) {
    updateAMMessageCompetitors(input: $input) {
      messages {
        scid
        version
        competitors {
          scid
          messageOption
          defaultMessage
          messages {
            audience {
              diversity
              zipCode {
                zipCode
                radius
              }
              state
              county {
                state
                county
              }
              sector
            }
            message
          }
        }
      }
    }
  }
`;

export default updateMajorsMessaging;
